module.exports = __webpack_public_path__ + "img/logo-peace-beta.b7dfc299.jpg";